import {
  APPROVE_PENDING_REQUEST_REQUEST,
  APPROVE_PENDING_REQUEST_SUCCESS,
  APPROVE_PENDING_REQUEST_FAILURE,
} from '../../../../Constants/actionTypes';

import { approvePendingRequestApi } from '../../../../Constants/apiService';

export const approvePendingRequestRequest = () => ({ type: APPROVE_PENDING_REQUEST_REQUEST });
export const approvePendingRequestSuccess = (data) => ({ type: APPROVE_PENDING_REQUEST_SUCCESS, payload: data });
export const approvePendingRequestFailure = (error) => ({ type: APPROVE_PENDING_REQUEST_FAILURE, payload: error });

export const approvePendingRequestAct = (requestId) => {
  return async (dispatch, getState) => {
    dispatch(approvePendingRequestRequest());

    const accessToken = getState()?.auth?.accessToken;

    try {
      const data = await approvePendingRequestApi(requestId, accessToken);
      dispatch(approvePendingRequestSuccess(data));
      return data;
    } catch (error) {
      const errorMessage =
        error?.message === 'Failed to fetch' || error?.message?.includes('NetworkError')
          ? 'Server is currently down. Please try again later.'
          : error?.message || 'Something went wrong';

      dispatch(approvePendingRequestFailure(errorMessage));
      return null;
    }
  };
};
